(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["growber-contact-support"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('growber-contact-support')) {
    customElements.define('growber-contact-support', class extends HTMLElement {
      connectedCallback() {
        if (this.contactConnected) return;
        this.contactConnected = true;
        this.events = new AbortController();
        this.issue = this.querySelector('[data-issue]');
        this.clipFields = this.querySelector('[data-clip-fields]');
        this.syncFields = () => {
          if (!this.issue || !this.clipFields) return;
          const showClips = this.issue.selectedOptions[0]?.dataset.issueKey === 'clips';
          this.clipFields.hidden = !showClips;
          this.clipFields.disabled = !showClips;
        };
        this.issue?.addEventListener('change', this.syncFields);
        window.addEventListener('pageshow', this.syncFields);
        this.syncFields();
        this.enhanceIssue();
        const status = this.querySelector('[data-response-status]');
        if (status && !window.Shopify?.designMode) {
          requestAnimationFrame(() => status.focus());
        }
      }
      disconnectedCallback() {
        this.contactConnected = false;
        this.events?.abort();
        this.issue?.removeEventListener('change', this.syncFields);
        window.removeEventListener('pageshow', this.syncFields);
      }
      enhanceIssue() {
        if (!this.issue) return;
        const select = this.issue;
        const signal = this.events.signal;
        const listen = (target, type, handler) => target.addEventListener(type, handler, { signal });
        const label = this.querySelector(`[id="${select.id}-label"]`);
        const error = this.querySelector('[data-issue-error]');
        let ui = this.issueUI;
        if (!ui) {
          const wrap = document.createElement('div');
          wrap.className = 'growber-contact__select';
          select.before(wrap);
          wrap.append(select);
          const trigger = document.createElement('button');
          trigger.type = 'button';
          trigger.className = 'growber-contact__select-trigger';
          trigger.id = `${select.id}-trigger`;
          trigger.setAttribute('aria-haspopup', 'listbox');
          trigger.setAttribute('aria-expanded', 'false');
          trigger.setAttribute('aria-describedby', error.id);
          const value = document.createElement('span');
          value.id = `${select.id}-value`;
          trigger.append(value);
          trigger.setAttribute('aria-labelledby', `${label.id} ${value.id}`);
          const menu = document.createElement('div');
          menu.id = `${select.id}-menu`;
          menu.className = 'growber-contact__select-menu';
          menu.setAttribute('role', 'listbox');
          menu.setAttribute('aria-labelledby', label.id);
          menu.hidden = true;
          trigger.setAttribute('aria-controls', menu.id);
          wrap.append(trigger, menu);
          ui = this.issueUI = { wrap, trigger, value, menu };
          select.classList.add('growber-contact__native-select');
          select.tabIndex = -1;
          select.setAttribute('aria-hidden', 'true');
          label.htmlFor = trigger.id;
        }
        const { wrap, trigger, value, menu } = ui;
        const close = () => { menu.hidden = true; trigger.setAttribute('aria-expanded', 'false'); };
        const items = () => Array.from(menu.querySelectorAll('[role="option"]:not(:disabled)'));
        const focusItem = (last = false) => {
          const available = items();
          const chosen = menu.querySelector('[aria-selected="true"]:not(:disabled)');
          (chosen || available[last ? available.length - 1 : 0])?.focus();
        };
        const open = (keyboard = false, last = false) => {
          menu.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
          if (keyboard) focusItem(last);
        };
        const sync = () => {
          value.textContent = select.selectedOptions[0]?.textContent || '';
          trigger.dataset.placeholder = select.value ? 'false' : 'true';
          trigger.disabled = select.disabled;
          items().forEach(item => item.setAttribute('aria-selected', String(item.dataset.value === select.value)));
          if (select.value) { error.hidden = true; trigger.removeAttribute('aria-invalid'); }
        };
        menu.replaceChildren();
        Array.from(select.options).filter(option => option.value).forEach(option => {
          const item = document.createElement('button');
          item.type = 'button';
          item.className = 'growber-contact__select-option';
          item.setAttribute('role', 'option');
          item.tabIndex = -1;
          item.dataset.value = option.value;
          item.textContent = option.textContent;
          item.disabled = option.disabled;
          listen(item, 'click', event => {
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            close();
            if (event.detail === 0) trigger.focus();
          });
          menu.append(item);
        });
        listen(trigger, 'click', event => menu.hidden ? open(event.detail === 0) : close());
        listen(trigger, 'keydown', event => {
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            open(true, event.key === 'ArrowUp');
          }
          if (event.key === 'Escape') close();
        });
        listen(menu, 'keydown', event => {
          const available = items();
          const index = available.indexOf(document.activeElement);
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            const step = event.key === 'ArrowDown' ? 1 : -1;
            available[(index + step + available.length) % available.length]?.focus();
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            available[event.key === 'Home' ? 0 : available.length - 1]?.focus();
          } else if (event.key === 'Escape') {
            event.preventDefault();
            close();
            trigger.focus();
          }
        });
        listen(document, 'click', event => { if (!wrap.contains(event.target)) close(); });
        listen(wrap, 'focusout', event => { if (event.relatedTarget && !wrap.contains(event.relatedTarget)) close(); });
        listen(select, 'change', sync);
        listen(select, 'invalid', event => {
          event.preventDefault();
          error.hidden = false;
          trigger.setAttribute('aria-invalid', 'true');
          close();
          trigger.focus();
        });
        listen(window, 'pageshow', sync);
        listen(select.form, 'reset', () => requestAnimationFrame(() => {
          close();
          error.hidden = true;
          trigger.removeAttribute('aria-invalid');
          sync();
          this.syncFields();
        }));
        sync();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (this.hasAttribute('data-menu-only-sticky')) {
        this.initMenuOnlySticky();
        return;
      }
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    initMenuOnlySticky() {
      this.header.classList.add('gbh-menu-only-sticky');
      this.mobileLogo = this.querySelector('.header__heading-link');
      this.paintMobileLogo = () => {
        this.logoFrame = null;
        if (!this.mobileLogo || !this.logoMotion) return;
        const progress = Math.min(1, Math.max(0, -this.header.getBoundingClientRect().top / this.logoMotion.offset));
        const p = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? (progress >= 0.99 ? 1 : 0) : progress;
        this.mobileLogo.style.transform = `translate(${this.logoMotion.x * p}px, ${this.logoMotion.y * p}px) scale(${1 + (this.logoMotion.scale - 1) * p})`;
      };
      const update = () => {
        const desktop = window.matchMedia('(min-width: 990px)').matches;
        const row = this.querySelector(desktop ? '.growber-home-menu' : 'header-drawer');
        if (!row) return;
        const offset = Math.max(0, row.getBoundingClientRect().top - this.header.getBoundingClientRect().top - 12);
        this.header.style.setProperty('--gbh-logo-scroll-offset', `${offset}px`);
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight - offset}px`);
        if (this.mobileLogo) {
          this.mobileLogo.style.transform = '';
          this.logoMotion = null;
          if (!desktop) {
            const logo = this.mobileLogo.getBoundingClientRect();
            const menu = row.getBoundingClientRect();
            const icons = this.querySelector('.header__icons').getBoundingClientRect();
            this.logoMotion = {
              offset: Math.max(1, offset),
              x: (menu.right + icons.left) / 2 - (logo.left + logo.width / 2),
              y: menu.top + menu.height / 2 - (logo.top + logo.height / 2),
              scale: Math.min(110, Math.max(60, icons.left - menu.right - 16)) / logo.width
            };
            this.paintMobileLogo();
          }
        }
      };
      this.mobileLogoScroll = () => {
        if (!this.logoFrame) this.logoFrame = requestAnimationFrame(this.paintMobileLogo);
      };
      window.addEventListener('scroll', this.mobileLogoScroll, { passive: true });
      this.menuResizeObserver = new ResizeObserver(update);
      this.menuResizeObserver.observe(this.header);
      this.menuResizeObserver.observe(this.querySelector('.header'));
      this.menuFrame = requestAnimationFrame(update);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      if (this.menuResizeObserver) {
        this.menuResizeObserver.disconnect();
        cancelAnimationFrame(this.menuFrame);
        cancelAnimationFrame(this.logoFrame);
        window.removeEventListener('scroll', this.mobileLogoScroll);
        return;
      }
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (!event.target.matches('.growber-range-sort select[name="sort_by"]')) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });

  } catch(e) { console.error(e); }
})();
})();
